import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { Box, Button,FormControl ,Select ,InputLabel,MenuItem , ToggleButton, ToggleButtonGroup, Divider } from '@mui/material';
import { getYears } from '../../utils/constCodeUtils';

import HeadquartersYearGoalContainer from './HeadquartersYearGoalContainer';
import HeadquartersMonthGoalContainer from './HeadquartersMonthGoalContainer';
import HeadquartersQuarterGoalContainer from './HeadquartersQuarterGoalContainer';


const HeadquarterSalesGoalContainer= () => {
    let navigate = useNavigate();
    const handleGoalEdit = () => {
        navigate('/salesgoalmng/edit');
    };

    const [years, setYears] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const [type, setType] = useState("year");
    const handleChangeType = (event, newType) => {
        setType(newType);
    }

    const handleChangeYear = (event)=>{
        setSelectedYear(event.target.value)
    }

    useEffect(() => {
        const arrYears = getYears(3,1);
        setYears(arrYears);
    }, [])





    return (
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Box sx={{ mr: 1, minWidth: 120 }}>
                        <FormControl  variant="standard"  fullWidth>
                            <InputLabel id="selected-year-label">기준년도</InputLabel>
                            <Select
                                labelId="selected-year-label"
                                id="selected-year"
                                value={selectedYear}
                                label="년도"
                                onChange={handleChangeYear}
                            >
                                {years && years.map((item,index)=>(
                                    <MenuItem key={index} value={item}>{item}</MenuItem>
                                ))}
                               
                            </Select>
                        </FormControl>
                    </Box>
                    <Box>
                        <ToggleButtonGroup
                            size="small"
                            color="primary"
                            value={type}
                            exclusive
                            onChange={handleChangeType}
                        >
                            <ToggleButton value="year">년도별</ToggleButton>
                            <ToggleButton value="month">월별</ToggleButton>
                            <ToggleButton value="quarter">분기별</ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
                <Box>
                    <Button variant="outlined" onClick={handleGoalEdit}>목표 관리 설정</Button>
                </Box>
            </Box>
            <Divider sx={{my:1}}/>
            <Box>
                {type ==='year' && <HeadquartersYearGoalContainer/>}
                {type ==='month' && <HeadquartersMonthGoalContainer/>}
                {type === 'quarter' && <HeadquartersQuarterGoalContainer />}
            </Box>
        </Box>
    )
}

export default HeadquarterSalesGoalContainer